import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = ({ toggleDarkMode, isDarkMode }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDialogueOpen, setIsDialogueOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    const handleClickOutside = (event) => {
      if (isDialogueOpen) {
        const dialogueBox = document.getElementById('dialogue-box');
        if (dialogueBox && !dialogueBox.contains(event.target)) {
          setIsDialogueOpen(false);
        }
      }

      const mobileMenu = document.getElementById('navbar-with-mega-menu');
      const menuButton = document.querySelector('button[aria-label="Toggle navigation"]');
      if (
        isMobileMenuOpen &&
        mobileMenu &&
        !mobileMenu.contains(event.target) &&
        menuButton &&
        !menuButton.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isDialogueOpen, isMobileMenuOpen]);

  return (
    <div>
      <header className={`fixed w-full py-2 transition-all duration-300 z-50 dark:bg-darkGray bg-white`}>
        <nav className="max-w-8xl w-full mx-auto px-6 sm:px-6 lg:px-6" aria-label="Global">
          <div className="flex items-center justify-between w-full">
            <Link to="/">
              <div className="py-2">
                <p className="bg-[#e4e4e4] text-[#424243] dark:bg-[black] dark:text-white rounded-sm p-4 py-2 sm:text-md font-bold md:text-2xl lg:text-2xl">海瑠</p>
              </div>
            </Link>

            <div className="flex items-center gap-3">
              <button
                onClick={toggleDarkMode}
                className="p-2 text-2xl text-purple dark:text-yellow-100"
              >
                {isDarkMode ? '☼' : '☾'}
              </button>

              <Link to="/">
                <button>
                  <p className="font-semibold text-xl dark:text-white text-black">✕</p>
                </button>
              </Link>
            </div>
          </div>
        </nav>
      </header>

    </div>
  );
};

export default Navbar;
